import { Environment } from '../app/core/models/environment.model';

export const commonEnvironment: Partial<Environment> = {
  // Bura gələcəkdə bütün mühitlərdə eyni olan konfiqurasiyalar əlavə edilə bilər
  // Məsələn: appVersion: '1.0.0'
};
